import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import {
  Committee,
  CommitteesGQL,
  GetAuthorsGQL,
  GetUnitiesGQL,
  GetUsersGQL,
  Idea,
  IdeaPage,
  PageChallengesGQL,
  RemoveIdeaGQL,
  SearchAllIdeasGQL,
  SearchAllIdeasQuery,
  SearchIdeaInput,
  Unity,
  User,
  SearchChallengeInput,
} from "../../../generated/graphql";
import { QueryRef } from "apollo-angular";
import moment from "moment";
import { ExcelService } from "../../service/excel.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserService } from "../../service/user.service";
import { IDropSettings } from "./interfaces/drop-settings.interface";
import {
  IGenerateUrlByChallengeType,
  IListChallenge,
} from "./interfaces/my-list.interface";
import { GetChallengesGQL } from "graphql/challenge/get-all-challenges.graphql";

declare var $: any;

@Component({
  selector: "app-my-list",
  templateUrl: "./my-list.component.html",
  styleUrls: ["./my-list.component.scss"],
})
export class MyListComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  user: User = new User();
  ideas: IdeaPage = new IdeaPage();

  status;
  getUnity;
  keyword = "";
  checked = true;
  private destroy$ = new Subject<void>();
  // filtro restaurado de 'filterIdea' (null quando não há filtro salvo)
  private restoredFilter: SearchIdeaInput | null = null;
  // ids salvos de Comitê/Autor/Desafio aguardando as opções carregarem. Necessário porque o
  // ng-multiselect-dropdown (writeValue) emite ngModelChange([]) na inicialização, o que zera
  // os ids em searchIdeaInput antes de as listas chegarem.
  private pendingDropIds: { committeeId?: string[]; authorName?: string[]; challengeName?: string[] } = {};

  searchIdeaInput: SearchIdeaInput = new SearchIdeaInput();
  filter: SearchChallengeInput = new SearchChallengeInput();
  getIdeasSearchQuery: QueryRef<SearchAllIdeasQuery>;

  filterStatus = [];
  listStatusDrop = [];
  author: Idea[] = [];
  authors: Idea[] = [];
  listStatusItems = [];
  users: Array<User> = [];
  unities: Array<Unity> = [];
  committee: Array<Committee> = [];
  committess: Array<Committee> = [];
  ListChallengeDrop: IListChallenge[];
  ListChallengeItems: IListChallenge[];

  dropSettings: IDropSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Marcar todos",
    unSelectAllText: "Desmarcar todos",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  dropSettingsAuthor: IDropSettings = {
    singleSelection: false,
    idField: "authorName",
    textField: "authorName",
    selectAllText: "Marcar todos",
    unSelectAllText: "Desmarcar todos",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  btnUnity: boolean;
  btnCommittee: boolean;
  deleteIdea: boolean;

  constructor(
    public router: Router,
    public loading: NgxSpinnerService,
    public translate: TranslateService,
    public searchAllIdeasGQL: SearchAllIdeasGQL,
    public getUnitiesGQL: GetUnitiesGQL,
    public committeesGQL: CommitteesGQL,
    public removeIdeiaGQL: RemoveIdeaGQL,
    public getChallenges: PageChallengesGQL,
    public getAllChallenges: GetChallengesGQL,
    public getUsersGQL: GetUsersGQL,
    public getAuthorsGQL: GetAuthorsGQL,
    public userService: UserService,
    public excelService: ExcelService,
  ) {
    super(router, loading, translate);

    // troca de idioma só retraduz as opções; o filtro salvo é mantido
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: LangChangeEvent) => {
        $(() => {
          this.createStatusArray();
          this.syncStatusItems(this.listStatusItems.map((s) => s.id));
          this.setChallengesValue();
        });
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.setDatePicker("picker-period", (start, end, label) => {
        this.searchIdeaInput.start = start.utcOffset(0, true).format();
        this.searchIdeaInput.end = end.utcOffset(0, true).format();
      });
      // exibe no campo o mesmo período salvo que a query usou (em vez do padrão de 30 dias)
      if (this.restoredFilter?.start && this.restoredFilter?.end) {
        const picker = $(".picker-period").data("daterangepicker");
        picker?.setStartDate(moment.utc(this.restoredFilter.start));
        picker?.setEndDate(moment.utc(this.restoredFilter.end));
      }
    }, 500)
  }

  ngOnInit() {
    this.searchIdeaInput.order ?? "name";

    this.userService.user.subscribe({
      next: (data) => {
        this.user = data as User;
        this.userProfile();
      },
      error: (err) => super.onError(err),
    });

    this.handlerFilterModel();
    this.createStatusArray();
    this.syncStatusItems();
    this.setChallengesValue();
    this.actionIdea();
    this.getUnities();
    this.committees();
    this.getAuthors();
  }

  createStatusArray() {
    this.listStatusDrop = [
      { id: "received", name: this.translate.instant("received") },
      { id: "analysis", name: this.translate.instant("analysis") },
      { id: "approved", name: this.translate.instant("approved") },
      { id: "denied", name: this.translate.instant("denied") },
      { id: "denial", name: this.translate.instant("denial") },
      { id: "awarded", name: this.translate.instant("awarded") },
      { id: "approved_award", name: this.translate.instant("approved_award") },
      { id: "finished", name: this.translate.instant("finished") },
      { id: "converted", name: 'Convertido' },
    ];
  }

  setChallengesValue() {
    const allChallenges = this.getAllChallenges.watch();
    allChallenges.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(({ data }) => {
      this.ListChallengeDrop = data.getChallenges.map((item) => {
        return {
          id: item.id,
          name: item.name === "GLOBAL" ? "Sem desafio" : item.name,
        };
      });
      const ids = this.takeDropIds("challengeName", (this.ListChallengeItems || []).map((c) => c.id));
      this.ListChallengeItems = this.ListChallengeDrop.filter((c) => ids.includes(c.id));
    });
  }

  getUnities() {
    this.getUnitiesGQL.watch().valueChanges.subscribe(({ data }) => {
      this.unities = data.getUnities as Array<Unity>;
    });
  }

  committees() {
    this.committeesGQL.watch().valueChanges.subscribe(({ data }) => {
      this.committee = data.committees as Array<Committee>;
      const ids = this.takeDropIds("committeeId", (this.committess || []).map((c) => c.id));
      this.committess = this.committee.filter((c) => ids.includes(c.id));
    });
  }

  getAuthors() {
    this.getAuthorsGQL.watch().valueChanges.subscribe(({ data }) => {
      this.author = data.getAuthors as Array<Idea>;
      const names = this.takeDropIds("authorName", (this.authors || []).map((a) => a.authorName));
      this.authors = this.author.filter(
        (a, i, arr) =>
          names.includes(a.authorName) &&
          arr.findIndex((x) => x.authorName === a.authorName) === i,
      );
    });
  }

  actionIdea() {
    this.loading.show();
    this.getIdeasSearchQuery = this.searchAllIdeasGQL.watch({ input: this.searchIdeaInput });
    this.getIdeasSearchQuery.valueChanges.subscribe({
      next: ({ data }) => {
        this.ideas = data.searchAllIdeas as IdeaPage;
        this.loading.hide();
      },
      error: (error) => {
        this.loading.hide();
      },
    });
  }

  actionClear() {
    this.keyword = undefined;
    this.getUnity = undefined;
    this.searchIdeaInput.page = 1;
    this.actionSearch();
  }

  actionSearch(pageChanged: boolean = false) {
    this.searchIdeaInput.status = [];

    this.listStatusItems.forEach((e) => {
      this.searchIdeaInput.status.push(e.id);
    });

    if (!pageChanged) {
      this.searchIdeaInput.page = 1;
    }
    super.setFilterLocal("filterIdea", this.searchIdeaInput);

    this.loading.show();
    this.actionIdea();
  }

  actionExcel() {
    this.loading.show();
    this.excelService.getExcelIdea(this.searchIdeaInput).subscribe({
      next: (data) => {
        this.downloadHandlerFile(data);
      },
      error: (err) => super.onError(err),
    });
  }

  pageChanged(event: number) {
    this.searchIdeaInput.page = event;
    this.actionSearch(true);
  }

  downloadHandlerFile(e) {
    const blob = new Blob([e], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    $("#btnDownload").attr("href", url);
    setTimeout(() => {
      this.loading.hide();
      $("#btnDownload")[0].click();
    });
  }

  cleanFilter() {
    this.searchIdeaInput.keyword = undefined;
    this.searchIdeaInput.unityId = undefined;
    this.searchIdeaInput.committeeId = undefined;
    this.searchIdeaInput.status = [];
    this.searchIdeaInput.challengeName = [];
    this.committess = [];
    this.authors = [];
    this.listStatusItems = [];
    this.ListChallengeItems = [];
    this.searchIdeaInput.authorName = undefined;
    this.searchIdeaInput.start = moment().subtract(29, 'days').utcOffset(0).startOf('day');
    this.searchIdeaInput.end = moment().utcOffset(0).endOf('day');
    this.setDatePicker("picker-period", (start, end, label) => {
      this.searchIdeaInput.start = start;
      this.searchIdeaInput.end = end;
    });
    this.pendingDropIds = {};
    localStorage.removeItem("filterIdea");
  }

  validateUser() {
    if (this.user.role !== "admin") {
      return false;
    }
    return true;
  }

  private handlerFilterModel() {
    const localFilter = super.getFilterLocal("filterIdea");
    const modelFormat = JSON.stringify(this.searchIdeaInput);
    if (!this.isNullOrUndefined(localFilter) && modelFormat !== localFilter) {
      // o período é aplicado ao date picker no ngAfterViewInit (aqui o picker ainda não existe);
      // Comitê/Autor/Desafio são remarcados quando as respectivas opções carregam
      this.searchIdeaInput = JSON.parse(localFilter);
      this.restoredFilter = JSON.parse(localFilter);
      this.pendingDropIds = {
        committeeId: this.restoredFilter.committeeId,
        authorName: this.restoredFilter.authorName,
        challengeName: this.restoredFilter.challengeName,
      };
    }
  }

  // ids a remarcar num dropdown: os restaurados (uma única vez) ou, depois, a seleção atual do
  // próprio dropdown (searchIdeaInput pode ter sido zerado pelo ngModelChange([]) da inicialização)
  private takeDropIds(key: "committeeId" | "authorName" | "challengeName", current: string[]): string[] {
    const ids = this.pendingDropIds[key] ?? current;
    delete this.pendingDropIds[key];
    return ids;
  }

  // remarca o dropdown de Status com os rótulos atuais (padrão: ids salvos em searchIdeaInput.status)
  private syncStatusItems(ids: string[] = this.searchIdeaInput.status || []) {
    this.listStatusItems = this.listStatusDrop.filter((s) => ids.includes(s.id));
  }

  userProfile() {
    switch (this.user.role) {
      case "admin":
        this.btnUnity = true;
        this.btnCommittee = true;
        this.deleteIdea = true;
        break;
      case "user":
        this.btnUnity = true;
        this.btnCommittee = true;
        this.deleteIdea = false;
        break;
      case "corporate-manager":
        this.btnUnity = true;
        this.btnCommittee = true;
        this.deleteIdea = true;
        break;
      case "local-manager":
        this.btnUnity = true;
        this.btnCommittee = true;
        this.deleteIdea = false;
        break;
      case "committee-member":
        this.btnUnity = false;
        this.btnCommittee = false;
        this.deleteIdea = false;
        break;
    }
  }

  onSelectDropCommitte($event: [Committee]) {
    this.searchIdeaInput.committeeId = $event.map((value) => value.id);
  }

  onSelectDropAuthors($event: [Idea]) {
    this.searchIdeaInput.authorName = $event.map((value) => value.authorName);
  }

  onSelectDropChallenge() {
    this.searchIdeaInput.challengeName = this.ListChallengeItems?.map(
      (item) => item.id,
    );
  }

  onDelete(id: string) {
    super.confirmMessage(
      "Atenção",
      "Deseja realmente excluir essa ideia?",
      () => {
        this.loading.show();
        this.removeIdeiaGQL.mutate({ id: id }).subscribe(
          () => {
            this.getIdeasSearchQuery.refetch({ input: this.searchIdeaInput });
            this.loading.hide();
          },
          (err) => super.onError(err),
        );
      },
    );
  }

  generateUrlByChallengeType({
    id,
    code,
  }: IGenerateUrlByChallengeType): string {
    return `/my-list-detail/${id}/${code}`;
  }
}
